module.exports = __webpack_public_path__ + "assets/img/cjwt1.947a8029.jpg";